export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14658.64cde296.jpg";